import * as request from './genericRequest';

const UsersRoute = 'users';

export const getAllUsers = async () => request.getApi(UsersRoute);
export const getUserById = async ({ id }) => request.getApi(`${UsersRoute}/${id}`);
export const postUser = async (user) => request.postApi(UsersRoute, user);
export const deleteUserByClientId = async (id) => request.deleteApi(`${UsersRoute}/${id}`);